var pageNumbers = {};

/**
 * We now load the first page of posts for each section via PHP.
 * So we need to set the initial page load to 2
 */
$(".wom-posts-section .card-wrapper").each(function () {
  var params = getParameters($(this));
  pageNumbers[params.index] = 2;
});

function loadPosts(
  type,
  index,
  categoryId,
  updateCategory,
  taxonomy,
  postsPerPage,
  linkText,
  taxonomy_ids,
  columns,
  searchValue
) {
  $(".wom-posts-section .card-wrapper .loading-icon").show();

  // if taxonomy_id is not set, set it to false
  if (typeof taxonomy_ids === "undefined") {
    taxonomy_ids = false;
  }

  if (typeof searchValue === "undefined") {
    searchValue = false;
  }

  $.ajax({
    url: settings.ajaxurl,
    type: "POST",
    data: {
      action: "more_post_ajax",
      linkText: linkText,
      postsPerPage: postsPerPage,
      pageNumber: pageNumbers[index],
      page_id: settings.page_id,
      type: type,
      category_id: categoryId ? categoryId : null,
      update_category: updateCategory ? updateCategory : false,
      taxonomy: taxonomy ? taxonomy : false,
      taxonomy_ids: taxonomy_ids,
      columns: columns ? columns : 4,
      searchValue: searchValue,
    },
    success: function (response) {
      $(".loading-icon").hide();

      /**
       * Response is an error message = page will be false
       * Response is a success message = page will be a number
       *
       * If page is false, or it is the first page we want to clear out the cards and show it from the start
       * otherwise we want to append the new cards to the existing ones
       */
      if (!response.page || response.page === 1) {
        $(`#post-excerpts-container-${index}`).html(response.html);
      } else {
        $(`#post-excerpts-container-${index}`).append(response.html);
      }

      var maxPosts = response.total_post_count;
      var countPosts = $(
        `#post-excerpts-container-${index} .archive-column`
      ).length;

      pageNumbers[index]++;

      if (countPosts === maxPosts || response.total_post_count === 0) {
        $(".archive-load-more").prop("disabled", true);
      } else {
        $(".archive-load-more").prop("disabled", false);
      }
    },
    fail: function () {
      $(".loading-icon").hide();
      $("#post-excerpts-container").append(
        '<p class="text-center">No more posts to load.</p>'
      );
    },
    complete: function () {
      $(".loading-icon").hide();
      $(".wom-posts-section .btn-category").removeClass("disabled");
    },
  });
}

function disableTarget(target) {
  target.prop("disabled", true);
}

function getRowIndex(target) {
  var rowIndex = target.data("row-index");
  return rowIndex;
}

function clearPosts(rowIndex) {
  $(`#archive-container-${rowIndex} .archive-column`).remove();
  $(`#archive-container-${rowIndex} p`).remove();
  pageNumbers[rowIndex] = 1;
}

function getParameters(target) {
  var type = $(target).parents(".wom-posts-section").attr("data-type");
  var index = getRowIndex($(target).parents(".wom-posts-section"));
  var categoryId = $(target)
    .parents(".wom-posts-section")
    .attr("data-category-id");
  var taxonomy = $(target).parents(".wom-posts-section").attr("data-taxonomy");
  var postsPerPage = $(target)
    .parents(".wom-posts-section")
    .attr("data-posts-per-page");
  var linkText = $(target).parents(".wom-posts-section").attr("data-link-text");
  var columns = $(target).parents(".wom-posts-section").attr("data-columns");

  return {
    type: type,
    index: index,
    categoryId: categoryId,
    taxonomy: taxonomy,
    postsPerPage: postsPerPage,
    linkText: linkText,
    columns: columns,
  };
}

$(".wom-posts-section .btn-category").on("click", function (event) {
  event.preventDefault();
  $(this)
    .parents(".wom-posts-section")
    .find(".btn-category")
    .removeClass("active");
  $(".wom-posts-section .btn-category").addClass("disabled");
  $(this).addClass("active");
  $(this)
    .parents(".wom-posts-section")
    .attr("data-category-id", $(this).attr("data-category-id"));
  var params = getParameters($(this));
  clearPosts(params.index);
  loadPosts(
    params.type,
    params.index,
    params.categoryId,
    true,
    params.taxonomy,
    params.postsPerPage,
    params.linkText,
    false,
    params.columns
  );
});

$(document).on("click", ".archive-load-more", function (event) {
  event.preventDefault();

  $(this)
    .parents(".wom-posts-section")
    .find('input[name="library_search"]')
    .val("");

  // get all filter-select values as an array
  var taxonomy_ids = [];
  $(this)
    .parents(".wom-posts-section")
    .find(".filter-select")
    .each(function () {
      var value = $(this).val();
      if (value != "" && !taxonomy_ids.includes(value)) {
        taxonomy_ids.push(value);
      }
    });

  var params = getParameters($(this));
  loadPosts(
    params.type,
    params.index,
    params.categoryId,
    false,
    params.taxonomy,
    params.postsPerPage,
    params.linkText,
    taxonomy_ids,
    params.columns
  );
});

// add support for filter-select as select2
$(".wom-posts-section .advanced-filter .filter-select").each(function () {
  var parentElement = $(this).parents(".select-wrapper2");
  $(this).select2({
    dropdownParent: parentElement,
  });
});

$(".wom-posts-section .filter-select").on("change", function (event) {
  $(this)
    .parents(".wom-posts-section")
    .find('input[name="library_search"]')
    .val("");

  // get all filter-select values as an array
  var taxonomy_ids = [];
  $(this)
    .parents(".wom-posts-section")
    .find(".filter-select")
    .each(function () {
      var value = $(this).val();
      if (value != "" && !taxonomy_ids.includes(value)) {
        taxonomy_ids.push(value);
      }
    });

  var params = getParameters($(this));
  clearPosts(params.index);
  loadPosts(
    params.type,
    params.index,
    params.categoryId,
    true,
    params.taxonomy,
    params.postsPerPage,
    params.linkText,
    taxonomy_ids,
    params.columns
  );
});

// add support for clear filters .clear-filter
$(".wom-posts-section .clear-filter").on("click", function (event) {
  event.preventDefault();

  $(this)
    .parents(".wom-posts-section")
    .find(".filter-select")
    .val("")
    .trigger("change");

  var params = getParameters($(this));
  clearPosts(params.index);
  loadPosts(
    params.type,
    params.index,
    params.categoryId,
    true,
    params.taxonomy,
    params.postsPerPage,
    params.linkText,
    false,
    params.columns
  );
});

// add support for search input
var debounceTimer;
$('.wom-posts-section input[name="library_search"]').on(
  "keyup",
  function (event) {
    var $this = $(this);

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var searchValue = $this.val();

      var params = getParameters($this);
      clearPosts(params.index);

      // reset all selects but don't trigger change event
      $this
        .parents(".wom-posts-section")
        .find(".filter-select")
        .val(null)
        .trigger("change.select2");

      loadPosts(
        params.type,
        params.index,
        params.categoryId,
        true,
        params.taxonomy,
        params.postsPerPage,
        params.linkText,
        false,
        params.columns,
        searchValue
      );
    }, 500); // 500ms delay
  }
);
